import Swal from "sweetalert2/dist/sweetalert2.js";

export const useMessageBox = () => {
  // Function to display an error message
  const showError = (title: string, text: string = "") => {
    Swal.fire({
      icon: "error",
      title,
      text,
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn fw-semibold btn-light-danger",
      },
    });
  };

  // Function to display an info message
  const showInfo = (title: string, text: string) => {
    Swal.fire({
      icon: "info",
      title,
      text,
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn fw-semibold btn-light-primary",
      },
    });
  };

  // Function to display a success message
  const showSuccess = (title: string, text: string = "", timer: number = 2000) => {
    Swal.fire({
      icon: "success",
      title,
      text,
      timer,
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn fw-semibold btn-light-primary",
      },
    });
  };

  // Function to display a confirmation box
  const showConfirm = async (
    title: string,
    text: string = "",
    confirmButtonText: string = "Có",
    cancelButtonText: string = "Không"
  ) => {
    const result = await Swal.fire({
      icon: "question",
      title,
      text,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      customClass: {
        confirmButton: "btn fw-semibold btn-light-primary",
        cancelButton: "btn fw-semibold btn-light-danger",
      },
    });

    return result.isConfirmed;
  };

  return {
    showError,
    showInfo,
    showSuccess,
    showConfirm,
  };
};
